import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Mgt1Service {

  constructor(private http: HttpClient, private httpService: HttpService) { }


  saveDetailsOfShares(object) {

      var request = {
          URL: "mgt1/addDetailsOfShares",
          DATA: object
      }
      return this.httpService.post(request);

  }
  updateDetailsOfShares(object) {

      var request = {
          URL: "mgt1/updateDetailsOfShares",
          DATA: object
      }
      return this.httpService.post(request);

  }



  updatePersonalDetails(data) {
      var request = {
          URL: "mgt1/updatePersonalDetails",
          DATA: data
      }
      return this.httpService.post(request);
  }

  updateDetailsOfMembers(data) {
      var request = {
          URL: "mgt1/updateDetailsOfMembers",
          DATA: data
      }
      return this.httpService.post(request);
  }




  getMgtList(object) {
      var registerList = {
          URL: "mgt1/getMgt1List/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);
  }
  deleteDetails(_id) {
      var request = {
          URL: "mgt1/deleteDetails/" + _id
      }
      return this.httpService.get(request);
  }
  getMgt1DetailsById(_id) {
      var editlist = {
          URL: "mgt1/getMgt1DetailsById/" + _id,
      }
      return this.httpService.get(editlist);
  }

  getHoldingList(_id, searchParam) {
      var holdingList = {
      URL: "mgt1/getHoldingList/" + _id,
      DATA: searchParam
      }
      return this.httpService.post(holdingList);
  }

  deleteholdingDetails(_id, Id) {
      var request = {
          URL: "mgt1/deleteHoldingDetails/" + _id + "/"+Id,
      }
      return this.httpService.get(request);
  }

  updateDetailsOfHolding(object) {
      var request = {
          URL: "mgt1/updateHoldingDetails",
          DATA: object
      }
      return this.httpService.post(request);
  }


  saveDetailsOfHolding(detailsOfHolding) {
      var request = {
          URL: "mgt1/saveDetailsOfHolding",
          DATA: detailsOfHolding
      }
      return this.httpService.post(request);

  }
  generateDetailsOfHoldingDocument(object) {
      var request = {
          URL: "mgt1/generateDetailsOfHoldingDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadDetailsOfHoldingFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mgt1/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadDetailsOfHoldingPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mgt1/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }


}